module.exports = __webpack_public_path__ + "static/media/header.0d4813b8.png";